import ReportInfo from './reportInfo.js';
import './styles.scss';

export default {
  ReportInfo
}